module.exports = __webpack_public_path__ + "img/character-example.73a0f296.png";